<div
  class="modal-dialog view-receipt-modal modal-dialog-scrollable m-0 scrollable-dialog"
>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">View Receipt ({{ data.deposit.id }})</h5>
      <span class="modal-x-button" (click)="onCloseDialog()">
        <i class="fa fa-times" aria-hidden="true"></i>
      </span>
    </div>
    <div class="modal-body">
      <ngb-carousel *ngIf="data.deposit.receipts.length > 0" (slide)="onSlideChange($event)">
        <ng-template
          ngbSlide
          *ngFor="let receipt of data.deposit.receipts; let i = index"
          id="ngb-slide-{{ i }}">
          <ng-container *ngIf="receipt.isPdf; else img">
            <iframe [src]="receipt.content"></iframe>
          </ng-container>
          <ng-template #img>
            <div class="picsum-img-wrapper">
              <div class="zoom-scroll-wrapper">
                <img
                  [src]="receipt.content | safe : 'resourceUrl'"
                  class="zoomable-receipt"
                  (click)="openImage(receipt.content)"
                />
              </div>
            </div>
          </ng-template>
        </ng-template>
      </ngb-carousel>
    </div>
    <div class="modal-footer" *ngIf="data.deposit.receipts.length > 0">
      <div class="receipt-info">
        <div class="info-row">
          <strong>Requested by:</strong>
          <span>
            {{ data.deposit.receipts[currentSlide]?.requested_by || '-' }} |
            <ng-container *ngIf="data.deposit.receipts[currentSlide]?.requested_at; else noDate">
              {{ data.deposit.receipts[currentSlide].requested_at | timezoneDate: 'YYYY-MM-DD HH:mm:ss' }}
            </ng-container>
            <ng-template #noDate>-</ng-template>
          </span>          
        </div>
        <div class="info-row">
          <strong>Uploaded by:</strong>
          <span>
            {{ data.deposit.receipts[currentSlide]?.created_by || '-' }} |
            {{ (data.deposit.receipts[currentSlide]?.created_at || '-') | timezoneDate: 'YYYY-MM-DD HH:mm:ss' }}
          </span>
        </div>
      </div>
      <button type="button" class="btn btn-secondary" (click)="onCloseDialog($event)">
        <i class="fas fa-ban"></i>Close
      </button>
    </div>
  </div>
</div>
